import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import Banner from '../../components/services/Banner';
import Investors from '../../components/investor';

const InvestorRelation = () => {
    useEffect(() => {
        window.scrollTo({top:0, left:0})
    }, [])

    return (
        <Grid container style={{width:'100%'}}>
            <Banner img={'/assets/images/investorsbanner.jpg'} title='Building services are the life force or "prana" of building structures.' />
            <Investors />
        </Grid>
    )

}

export default InvestorRelation;